import env from 'config/env'

const PURPOSE_TOP_VID = Object.freeze({
  teaser: `${env.MEDIA_CLOUDFRONT_URL}img/purpose-19/w_purpose_video.mp4`,
  teaserMobile: `${env.MEDIA_CLOUDFRONT_URL}img/purpose-19/m_purpose_video.mp4`,
})

export default PURPOSE_TOP_VID
